import { el, list, mount } from 'redom';

import keys from 'constants/keys';

import Value from './value';

class MultipleValuesInput {

  constructor(options) {

    this.onSearchTextChange = options.onSearchTextChange;
    this.onChange = options.onChange;
    this.onArrowUpKey = options.onArrowUpKey;
    this.onArrowDownKey = options.onArrowDownKey;
    this.onEnterKey = options.onEnterKey;
    this.values = options.values;
    this.placeholder = options.placeholder || '';

    this.input = null;
    this.valuesList = null;

    this.initializeInput();
    this.initializeValuesList();

    this.el = el('.multiple-values-input-main.hide-scrollbar', {
      onclick: this.handleMainContainerClick.bind(this)
    }, [this.valuesList]);
  }

  initializeValuesList() {

    this.valuesList = list('div.multiple-values-input-values-list', Value, null, {
      onRemove: this.removeValue.bind(this)
    });

    this.setValues(this.values);

  }

  initializeInput() {

    this.input = el('input.multiple-values-input-text-input', {
      placeholder: this.placeholder,
      onkeydown: this.handleTextInputKeyDownEvent.bind(this),
      onkeyup: this.handleTextInputChangeEvent.bind(this)
    });
    this.input.previousValue = '';

  }

  handleTextInputKeyDownEvent(event) {

    const key = event.key;

    if (key === keys.ARROW_UP) {
      this.onArrowUpKey();
    } else if (key === keys.ARROW_DOWN) {
      this.onArrowDownKey();
    } else if (key === keys.ENTER) {
      this.onEnterKey();
    }

  }

  handleTextInputChangeEvent(event) {

    const previousValue = this.input.previousValue;
    const currentValue = event.target.value;

    if (previousValue === currentValue) {
      return;
    }

    this.input.previousValue = currentValue;

    this.onSearchTextChange(currentValue);

  }

  focus() {

    this.input.focus();

  }

  reset() {

    this.input.value = '';

  }

  removeValue(index) {

    const values = [...this.values];

    values.splice(index, 1);

    this.setValues(values);

    this.onChange(values);

    this.focus();

  }

  setValues(values) {

    this.values = values;

    this.valuesList.update(this.values);

    mount(this.valuesList, this.input);

  }

  handleMainContainerClick(event) {

    event.stopPropagation();

    this.focus();

    return this;

  }

}

export default MultipleValuesInput;